import {
    MIXPANEL_CLICK_EVENT_NAME,
    MIXPANEL_COMPONENT_NAME,
} from '../../../../components/EventReportingManager/constants';

export const getEventContext = ({ componentName, eventEnrichment, eventName }) => ({
    bq: {
        'page.element.type': componentName,
        ...eventEnrichment,
    },
    mixpanel: {
        [MIXPANEL_COMPONENT_NAME]: componentName,
        [MIXPANEL_CLICK_EVENT_NAME]: eventName,
        ...eventEnrichment,
    },
});
